import { AnimatePresence } from 'motion/react';
import * as motion from 'motion/react-m';
import type { FC, PropsWithChildren } from 'react';

export const AnimatedWrapper = AnimatePresence;

interface AnimatedItemProps {
  delay?: number;
  duration?: number;
  layout?: boolean;
}

export const AnimatedItem: FC<PropsWithChildren<AnimatedItemProps>> = ({
  children,
  delay,
  duration = 0.3,
  ...rest
}) => (
  <motion.div
    animate={{ opacity: 1, x: 0, scale: 1, transform: 'none' }}
    exit={{ opacity: 0, x: 0, scale: 0.5, transform: 'none' }}
    initial={{ opacity: 0, x: 0, scale: 0.5, transform: 'none' }}
    transition={{ duration, delay }}
    {...rest}
  >
    {children}
  </motion.div>
);
